import React, { useLayoutEffect } from "react";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { withWebModalStack } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModalStack";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { WorkspaceProductQuery } from "./__generated__/WorkspaceProductQuery.graphql";
import { useNavigationHeaderOptions } from "../../common/navigationHeaderOptions";
import { ProductHeader } from "../Product/ProductHeader";

function InnerWorkspaceProductMain(
  props: UserLoggedInNavigatorScreenProps<"WorkspaceProduct"> & {
    fetchKey: string;
  }
) {
  const getOpts = useNavigationHeaderOptions();
  useLayoutEffect(() => {
    props.navigation.setOptions(
      getOpts({
        type: "CLOSE",
        title: "",
        onClose: () => {
          props.navigation.goBack();
        },
      })
    );
  }, [getOpts, props.navigation]);

  const data = useLazyLoadQuery<WorkspaceProductQuery>(
    graphql`
      query WorkspaceProductQuery($id: ID!) {
        workspaceProduct(id: $id) @required(action: THROW) {
          ...ProductHeader_ProductDetails
        }
      }
    `,
    {
      id: props.route.params.id,
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  return <ProductHeader product={data.workspaceProduct} />;
}

export const WorkspaceProduct = withWebModalStack(
  (props: UserLoggedInNavigatorScreenProps<"WorkspaceProduct">) => {
    return (
      <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
        {(fetchKey) => (
          <InnerWorkspaceProductMain {...props} fetchKey={fetchKey} />
        )}
      </LazyQueryNetworkBoundrary>
    );
  },
  true
);
